import { useState, useEffect } from 'react'
import { getUserProfile } from '../api/api'

export function useMerchant() {
  const [merchantId, setMerchantId] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    const fetchMerchantInfo = async () => {
      try {
        setLoading(true)
        const userProfile = await getUserProfile()

        // Check for entityType case-insensitively to handle both 'merchant' and 'MERCHANT'
        // Also handle the case where entityType might be null or undefined
        const entityType = userProfile.entityType?.toLowerCase() || ''
        if (userProfile.entityId && entityType === 'merchant') {
          setMerchantId(userProfile.entityId)
        }
        setLoading(false)
      } catch (err) {
        console.error('Failed to fetch merchant info:', err)
        setError(err instanceof Error ? err : new Error('Failed to fetch merchant info'))
        setLoading(false)
      }
    }

    fetchMerchantInfo()
  }, [])

  return { merchantId, loading, error }
}
